var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        { attrs: { label: "Size" } },
        [
          _c(
            "b-input-group",
            {
              scopedSlots: _vm._u([
                {
                  key: "append",
                  fn: function () {
                    return [
                      _c("b-input", {
                        attrs: { max: 100, min: 0, type: "number" },
                        on: { input: _vm.changeEffect },
                        model: {
                          value: _vm.size,
                          callback: function ($$v) {
                            _vm.size = $$v
                          },
                          expression: "size",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("b-input", {
                attrs: { max: 200, min: 0, type: "range" },
                on: { input: _vm.changeEffect },
                model: {
                  value: _vm.size,
                  callback: function ($$v) {
                    _vm.size = $$v
                  },
                  expression: "size",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Spread" } },
        [
          _c(
            "b-input-group",
            {
              scopedSlots: _vm._u([
                {
                  key: "append",
                  fn: function () {
                    return [
                      _c("b-input", {
                        attrs: { max: 100, min: 0, type: "number" },
                        on: { input: _vm.changeEffect },
                        model: {
                          value: _vm.spread,
                          callback: function ($$v) {
                            _vm.spread = $$v
                          },
                          expression: "spread",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("b-input", {
                attrs: { max: 100, min: 0, type: "range" },
                on: { input: _vm.changeEffect },
                model: {
                  value: _vm.spread,
                  callback: function ($$v) {
                    _vm.spread = $$v
                  },
                  expression: "spread",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Color" } },
        [
          _c("ColorPicker", {
            attrs: { opacity: "", copy: "", position: "right-middle" },
            on: { input: _vm.changeEffect },
            model: {
              value: _vm.color,
              callback: function ($$v) {
                _vm.color = $$v
              },
              expression: "color",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }